/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data IDs used in the logs table screen.
 */
export const LOGS_TABLE_DATA_IDS = {
  emptyState: `Table: No logs found`,
  logLevelTooltip: `Tooltip: Log level`,
  logsTable: 'Table: Logs',
};
